import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Section } from '../layout';
import { Card } from '../common';
import { skillCategories } from '../../data';

const tagColorMap: Record<string, string> = {
  languages: 'border-cyber-green/40 text-cyber-green bg-cyber-green/10 hover:bg-cyber-green/20',
  embedded: 'border-cyber-cyan/40 text-cyber-cyan bg-cyber-cyan/10 hover:bg-cyber-cyan/20',
  security: 'border-cyber-purple/40 text-cyber-purple bg-cyber-purple/10 hover:bg-cyber-purple/20',
  tools: 'border-cyber-green/40 text-cyber-green bg-cyber-green/10 hover:bg-cyber-green/20',
};

const headerColorMap: Record<string, string> = {
  languages: 'text-cyber-green',
  embedded: 'text-cyber-cyan',
  security: 'text-cyber-purple',
  tools: 'text-cyber-green',
};

export function Skills() {
  const { t } = useTranslation();

  return (
    <Section id="skills" title={t('skills.title')}>
      <div className="grid md:grid-cols-2 gap-8">
        {skillCategories.map((category, index) => (
          <motion.div
            key={category.id}
            initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <Card>
              <h3 className={`text-xl font-cyber mb-6 ${headerColorMap[category.id] || 'text-cyber-cyan'}`}>
                {t(category.name)}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.skills.map((skill) => (
                  <span
                    key={skill.name}
                    className={`px-3 py-1.5 text-sm font-mono border rounded transition-colors duration-200 ${tagColorMap[category.id]}`}
                  >
                    {skill.name}
                  </span>
                ))}
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
